import React from 'react';
import { X } from 'lucide-react';
import { STUDIO_COPY } from '../config';
import studioAppIcon from '../assets/scoutlytics-studio-app-icon-192.png';

type StudioMobileAppBannerProps = {
  isStandalone: boolean;
  isMobileWeb: boolean;
  isDismissed: boolean;
  onDismiss: () => void;
  onOpen: () => void;
};

/**
 * Dismissible "Mobile App" banner. Hidden when installed, on desktop, or
 * after dismiss. CTA opens the instructions modal — it does not fire the
 * native prompt itself.
 */
const StudioMobileAppBanner: React.FC<StudioMobileAppBannerProps> = ({
  isStandalone,
  isMobileWeb,
  isDismissed,
  onDismiss,
  onOpen,
}) => {
  if (isStandalone || !isMobileWeb || isDismissed) {
    return null;
  }

  return (
    <div
      className="studio-mobile-app-banner"
      data-testid="studio-mobile-app-banner"
      role="region"
      aria-label={STUDIO_COPY.mobileAppBannerLabel}
    >
      <div className="studio-mobile-app-banner-icon" aria-hidden>
        <img
          src={studioAppIcon}
          alt=""
          width={36}
          height={36}
          className="studio-mobile-app-banner-icon-img"
        />
      </div>
      <div className="studio-mobile-app-banner-copy">
        <p className="studio-mobile-app-banner-label">{STUDIO_COPY.mobileAppBannerLabel}</p>
        <p className="studio-mobile-app-banner-body">{STUDIO_COPY.mobileAppBannerBody}</p>
        <button
          type="button"
          className="studio-btn-primary studio-mobile-app-banner-cta"
          onClick={onOpen}
          data-testid="studio-mobile-app-banner-cta"
        >
          {STUDIO_COPY.mobileAppBannerCta}
        </button>
      </div>
      <button
        type="button"
        className="studio-mobile-app-banner-dismiss"
        onClick={onDismiss}
        aria-label={STUDIO_COPY.mobileAppDismissBanner}
        data-testid="studio-mobile-app-banner-dismiss"
      >
        <X className="h-4 w-4" aria-hidden />
      </button>
    </div>
  );
};

export default StudioMobileAppBanner;
